import Grid from "./Grid";
import React, { useState, Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Text, PerspectiveCamera } from "@react-three/drei";
import * as THREE from "three";
import Box from "@mui/material/Box";
import Controls from "./Controls";
import { Color, Vector3 } from "three";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import Loader from "../../utils/Loader";

const Cube = ({ position, rotation, scale = new Vector3(1, 1, 1) }) => {
  var arrowScene = new THREE.Scene();

  var arrowPos = new THREE.Vector3(0, 0, 0);
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(1, 0, 0),
      arrowPos,
      5,
      0x7f2020,
      1,
      0.5
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 1, 0),
      arrowPos,
      5,
      0x207f20,
      1,
      0.5
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 0, 1),
      arrowPos,
      5,
      0x20207f,
      1,
      0.5
    )
  );

  const gltf = useLoader(GLTFLoader, "/dog.glb");
  return (
    <group position={position} rotation={rotation} scale={scale}>
      <primitive object={gltf.scene} rotation={[0, Math.PI / 2, Math.PI / 2]} />
      <primitive object={arrowScene} />
    </group>
  );
};

const Scene = ({ xPosition, yPosition, zPosition }) => {
  const bgColor = new Color(0xecf0f1);
  var arrowScene = new THREE.Scene();

  var arrowPos = new THREE.Vector3(0, 0, 0);
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(1, 0, 0),
      arrowPos,
      5,
      0xe37b7b,
      1,
      0.5
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 1, 0),
      arrowPos,
      5,
      0x5bc75b,
      1,
      0.5
    )
  );
  arrowScene.add(
    new THREE.ArrowHelper(
      new THREE.Vector3(0, 0, 1),
      arrowPos,
      5,
      0x70c9e6,
      1,
      0.5
    )
  );

  return (
    <>
      <PerspectiveCamera
        makeDefault
        up={[0, 0, 1]}
        fov={50}
        position={[10, 10, 10]}
        rotation={[60, 0, 0]}
      />
      <color attach="background" args={[bgColor.r, bgColor.g, bgColor.b]} />
      <Suspense fallback={<Loader />}>
        <OrbitControls />
        <ambientLight intensity={2} />
        <Grid size={10} />

        <primitive object={arrowScene} />
        <Cube
          rotation={[0, 0, 0]}
          position={[xPosition, yPosition, zPosition]}
        ></Cube>
      </Suspense>
    </>
  );
};

function Main() {
  const [xPosition, setXPosition] = useState(0.5);
  const [yPosition, setYPosition] = useState(1);
  const [zPosition, setZPosition] = useState(0.8);

  const [xRotation, setXRotation] = useState(0);
  const [yRotation, setYRotation] = useState(0);
  const [zRotation, setZRotation] = useState(0);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "column", md: "row" },
        height: "100%",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Controls
          controls={{
            xPosition,
            yPosition,
            zPosition,
            xRotation,
            yRotation,
            zRotation,
            setXPosition,
            setYPosition,
            setZPosition,
            setXRotation,
            setYRotation,
            setZRotation,
          }}
        />
      </Box>
      <Box sx={{ flex: 2, width: "100%", minHeight: 600 }}>
        <Canvas>
          <Scene
            xPosition={xPosition}
            yPosition={yPosition}
            zPosition={zPosition}
          />
        </Canvas>
      </Box>
    </Box>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
}

function Translation(props: TabPanelProps) {
  const { children, ...other } = props;

  return <Main />;
}

export default Translation;
